// Generated from config.schema.json — do not edit.
import { z } from 'zod';

export const frontendConfigSchema = z
  .object({
    /**Google Tag Manager container ID injected into the frontend*/
    gtmContainerId: z.string().describe('Google Tag Manager container ID injected into the frontend').optional(),
    /**Sourcepoint privacy manager ID for the consent dialog*/
    privacyManagerId: z.string().describe('Sourcepoint privacy manager ID for the consent dialog').optional(),
    /**Base waipu domain for the current environment (e.g. waipu-dev.net, waipu-preview.net, waipu.tv)*/
    waipuDomain: z
      .string()
      .describe('Base waipu domain for the current environment (e.g. waipu-dev.net, waipu-preview.net, waipu.tv)')
      .default('waipu.tv'),
    sentry: z
      .object({
        /**Sentry DSN for frontend error reporting*/
        dsn: z.string().describe('Sentry DSN for frontend error reporting').optional(),
        /**enable Sentry error reporting in the frontend*/
        enabled: z.boolean().describe('enable Sentry error reporting in the frontend').optional(),
      })
      .strict()
      .optional(),
    /**Frontend log level*/
    logLevel: z.enum(['debug', 'info', 'warn', 'error', 'silent']).describe('Frontend log level').default('info'),
    runtimeEnvironment: z.enum(['local', 'dev', 'preview', 'prod']).default('local'),
    appVersion: z.string().default('0.0.0'),
    /**reCAPTCHA v3 site key for frontend bot protection*/
    recaptchaSiteKey: z.string().describe('reCAPTCHA v3 site key for frontend bot protection').optional(),
    /**Google OAuth client ID for One Tap / Sign-In*/
    googleClientId: z.string().describe('Google OAuth client ID for One Tap / Sign-In').optional(),
    /**Login with Amazon client ID*/
    amazonClientId: z.string().describe('Login with Amazon client ID').optional(),
    /**Sign in with Apple client ID*/
    appleClientId: z.string().describe('Sign in with Apple client ID').optional(),
    /**Google Maps JavaScript API key (domain-restricted) for Places Autocomplete in address forms*/
    googleMapsApiKey: z
      .string()
      .describe('Google Maps JavaScript API key (domain-restricted) for Places Autocomplete in address forms')
      .optional(),
    /**Billwerk public key for the payment SDK*/
    billwerkPublicKey: z.string().describe('Billwerk public key for the payment SDK').optional(),
    /**Billwerk payment SDK URL*/
    billwerkSdkUrl: z.string().describe('Billwerk payment SDK URL').optional(),
    /**Billwerk PayPal payment method identifier (Method:Provider) for this environment's PSP configuration*/
    billwerkPayPalBearer: z
      .string()
      .describe("Billwerk PayPal payment method identifier (Method:Provider) for this environment's PSP configuration")
      .optional(),
  })
  .strict();
export type FrontendConfig = z.infer<typeof frontendConfigSchema>;
